import { useRef } from "react";
import { Table } from "./Table";
import { Toast } from "primereact/toast";

export const LeadScrappingJobs = () => {
    const toast = useRef<any>();
    return (
        <>
            <Table toast={toast} />
            <Toast ref={toast} />
        </>
    );
}